import BannerSubhome from "../../components/bannerSubhome";
import Contato from "../../components/contato";
import BannerVenturesEstrategia from "../../components/bannerVenturesEstrategia";
import InvestimosVentures from "../../components/investimosVentures";
import LinksVentures from "../../components/linksVentures";
import BusinessOtimize from "../../components/businessOtimize";
import DiferenciaisVentures from "../../components/DiferenciaisVentures";
import Rodape from "../../components/rodape";

function Ventures() {
    return (
        <>
            <Contato />
            <BannerSubhome
                image="banner_ventures.png"
                imageMobile="banner_ventures_mobile.png"
                title="VENTURES"
                subtitle={
                    <>
                        ONDE <strong>IDEIAS</strong> GANHAM <strong>DIREÇÃO</strong>.
                    </>
                }
                marca={{
                    color: "#331175",
                    logoSrc: "../assets/logo_holding.svg",
                }}
                hoveredBrand="projectiva"
                brands={[{ id: "projectiva" }]}
            />     
            <InvestimosVentures />
            <LinksVentures
                areasData={[
                    {
                        logo: "../assets/logo_chatroute.svg",
                        text: "Atendimento unificado via WhatsApp e outros canais, com gestão inteligente de conversas. Mais agilidade, organização e proximidade no relacionamento com seus clientes.",
                        glowColor: "#A002CB",
                        url: "https://www.chatroute.com.br/",
                    },
                    {
                        logo: "../assets/logo_imobshoot.svg",
                        text: "App para captura de imagens profissionais de imóveis, com tratamento automático e organização inteligente.",
                        glowColor: "#A002CB",
                        url: "https://www.imobshoot.com.br/",
                    },
                    {
                        logo: "../assets/logo_fluxlaw.svg",
                        text: "Automação de processos jurídicos com inteligência artificial. Escala, controle e eficiência para escritórios e departamentos jurídicos.",
                        glowColor: "#A002CB",
                        url: "https://fluxlaw.ai/",
                    },
                ]}
            />
            <BannerVenturesEstrategia
                headingBold="Estratégia, estrutura e execução para "
                headingText="transformar boas ideias em grandes negócios."
                buttonText="Saber mais"
                buttonUrl="/"
            />
            <DiferenciaisVentures />
            <BusinessOtimize
                backgroundImage="../assets/background_ventures.png"
                bgMobile="../assets/background_ventures_mobile.png"
                title={
                    <>
                    <span className="font-inter-bold text-4xl md:text-[40px]">
                        Vamos escalar <br className="block md:hidden" />
                    </span>
                        <span className="text-4xl md:text-[40px]"> o seu negócio?</span>
                    </>
                }
                buttonText="Fale conosco"
                buttonTextColor="from-[#422776] to-[#422776]"
                buttonLink="#"
            />
            <Rodape />
        </>
    );
}

export default Ventures;
